import { useCallback, useState } from 'react';
import useFetch, { ServiceParams, ServiceResponse } from '../hooks/useFetch';
import EndPoints from '../config/EndPoint';
import { ServiceNote, ServiceNoteCreate, ServiceNotesListResponse } from '../models/ServiceNoteModel';

export type ServiceNotesEvents = Partial<{
  onSuccess: (r: ServiceResponse) => void;
  onError: (r: ServiceResponse) => void;
}>;

/**
 * Hook para CRUD de notas de servicio.
 * - listByService: GET notas de un servicio
 * - store: POST crear nota (solo texto; user y fecha/hora los asigna el backend)
 */
const useServiceNotesService = () => {
  const { doGet, doPost } = useFetch();
  const [fetching, setFetching] = useState<Record<string, boolean>>({});

  const setFlag = useCallback((key: string, val: boolean) => {
    setFetching(prev => ({ ...prev, [key]: val }));
  }, []);

  const listByService = useCallback(
    (serviceId: number, events: ServiceNotesEvents = {}) =>
      doGet({
        url: EndPoints.SERVICES.NOTES_LIST.replace(':service_id', String(serviceId)),
        setFetching: v => setFlag('list', v),
        ...events,
      } as ServiceParams),
    [doGet, setFlag]
  );

  const store = useCallback(
    (serviceId: number, payload: ServiceNoteCreate, events: ServiceNotesEvents = {}) =>
      doPost({
        url: EndPoints.SERVICES.NOTES_STORE.replace(':service_id', String(serviceId)),
        body: payload,
        setFetching: v => setFlag('store', v),
        ...events,
      } as ServiceParams),
    [doPost, setFlag]
  );

  return {
    fetching,
    listByService,
    store,
  };
};

export default useServiceNotesService;
export type { ServiceNotesListResponse };
